const SectionShell = ({ number, title, subtitle, children }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
      <div className="flex items-center gap-2 pb-4 border-b border-gray-100 mb-4">
        <div className="w-7 h-7 rounded-lg bg-black flex items-center justify-center text-white flex-shrink-0">
          <span className="text-xs font-semibold">{number}</span>
        </div>
        <div>
          <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
          <p className="text-xs text-gray-500">{subtitle}</p>
        </div>
      </div>
      {children}
    </div>
  );
};

export default SectionShell;

